//removeIf(production)
import ClaroluzEvents from "../../../../../infra/critical/claroluz-events";
import ClaroluzOffer from "../../../../../domain/entities/claroluz-offer";
import ClaroluzModal from "./claroluz-modal";
//removeIf(production)
const HystModal = require('../../../../../external/hystmodal/hystmodal');
//endRemoveIf(production)

class ClaroluzModalDetail extends ClaroluzModal {
    private offer: ClaroluzOffer | null;

    constructor() {
        const library = new HystModal({
            linkAttributeName: "data-hystmodal",

        });

        super(library, '#claroluz-modal-detail');
        this.offer = null;
        this.showEvent();
        this.hideEvent();
    }

    private showEvent() {
        document.addEventListener('claroluz_Detail_show', (event: any) => {
            this.offer = event.detail;

            this.modal.open(this.id);

            new ClaroluzEvents(appProperties(), 'modal', 'detail', 'open');
        });
    }

    private hideEvent() {
        document.addEventListener('claroluz_Detail_hide', () => {
            this.modal.close();

            new ClaroluzEvents(appProperties(), 'modal', 'detail', 'close');
        });
    }
}

//removeIf(production)
function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}

export default ClaroluzModalDetail;
//endRemoveIf(production)
